/*

  loadJSONP(
    'http://www.gigpark.com/businesses/runlevel6.json',
    function(data) {
      console.log(data);
    }
  );

*/

const loadJSONP = (() => {
  var unique = 0;
  return ({url, name = '_jsonp_' + unique++, data = {}}) => {
    return new Promise(resolve=>{
      // INIT
      if (url.match(/\?/)) url += "&callback="+name;
      else url += "?callback="+name;
      
      // Create script
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url + (!!data ? '&' + Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&') : '');
      
      // Setup handler
      window[name] = data => {
        resolve(data);
        script.remove();
        script = null;
        delete window[name];
      };
      
      // Load JSON
      document.head.appendChild(script);  
    });
    
  };
})();

export default loadJSONP;